import { render, staticRenderFns } from "./MangaStage.vue?vue&type=template&id=4af831e4&scoped=true&"
import script from "./MangaStage.vue?vue&type=script&lang=js&"
export * from "./MangaStage.vue?vue&type=script&lang=js&"
import style0 from "./MangaStage.vue?vue&type=style&index=0&id=4af831e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af831e4",
  null
  
)

export default component.exports